import React from "react"
import './MainPage.css';
import { COLORS } from "../../constants/colors"
import { Box, Button, Grid, Link, TextField, Tooltip, Typography } from "@mui/material";
import { ExpandMore, GitHub, Instagram, LinkedIn, Send, Twitter } from "@mui/icons-material";
import { projects } from "../../constants/projects";
import Project from "../../components/Project/Project";
import { blogs } from "../../constants/blogs";
import Blog from "../../components/Blog/Blog";
import Footer from "../../components/Footer/Footer";
const MainPage = () => {

    const shortSkills = ["javascript", "mongodb", "express", "angular", "react", "nodejs", "vscode"];
    const skills = ["html", "css", "javascript", "mongodb", "express", "angular", "nodejs", "mysql", "docker", "vscode"];
    return <>
        <div className="hero-container" style={{ backgroundColor: COLORS.primary1 }}>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container>
                    <Grid item md={6}>
                        <div className="hero-container-desc">
                            <Typography variant="p" color={COLORS.white}>
                                Hello &#x1F44B;
                            </Typography>
                            <Typography variant="h3" color={COLORS.secondry} className="title">
                                I'm a Full Stack Developer
                            </Typography>
                            <Typography variant="h4" color={COLORS.white}>
                                I build things for web
                            </Typography>
                            <div className="social-icons">
                                <Link style={{backgroundColor:'#000'}} href='https://github.com/mjmaurya' className="social-icon" color={COLORS.white}><GitHub/></Link>
                                <Link style={{backgroundColor:'#0077B5'}} href='https://www.linkedin.com/in/mjmaurya' className="social-icon" color={COLORS.white}><LinkedIn /></Link>
                                <Link style={{backgroundColor:'#1DA1F2'}} href='https://x.com/manojkushwaha__' className="social-icon" color={COLORS.white} ><Twitter /></Link>
                                <Link style={{backgroundColor:'#E4405F'}} href='https://www.instagram.com/mj.cs_/' className="social-icon" color={COLORS.white} ><Instagram /></Link>
                            </div>
                        </div>
                    </Grid>
                    <Grid item md={6}  style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }} >
                        <img width={'60%'} height={'100%'}  src={`${process.env.PUBLIC_URL}/profile2.png`} alt="Manoj Kumar" />
                    </Grid>
                </Grid>
            </Box>
        </div>
        <Box sx={{ flexGrow: 1 }} className="short-skill section" style={{ backgroundColor: COLORS.primary }}>
            <Grid container style={{ height: '100%' }}>
                <Grid item md={6} >
                    <Grid container>
                        <Grid item xs={6} style={{display:'flex', alignItems:'center', color:'#fff'}}>
                            <Typography variant="h2" className="heading" mr={2}>4</Typography>
                            <Typography variant="p">Years of <br/> Experience</Typography>
                        </Grid>
                        <Grid item xs={6} style={{display:'flex', alignItems:'center', color:'#fff'}}>
                            <Typography variant="h2" className="heading" mr={2}>10+</Typography>
                            <Typography variant="p">Projects <br/> Done</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} >
                    <div className="short-skill-container">
                        {shortSkills.map(skill => <div key={skill} className="short-skill-icon"><img width={'100%'} src={`${process.env.PUBLIC_URL}/skills/${skill}.png`} alt={`${skill}`} /></div>)}
                    </div>
                </Grid>
            </Grid>
        </Box>

        <Box sx={{ flexGrow: 1 }} id="about" className="section section-about" style={{ backgroundColor: COLORS.gray1 }}>
            <Grid container style={{ height: '100%' }} className="about section" spacing={2}>
                <Grid item md={6} >
                    <Typography variant="h4" className="heading" color={COLORS.primary1} mb={2}>About Me</Typography>
                    <Typography variant="p" className="about-me" color={COLORS.primary1}>
                        I am a versatile full-stack developer specializing in the MEAN stack, adept at crafting robust web solutions from frontend to backend. With a keen eye for detail and a passion for problem-solving, I excel in creating dynamic and intuitive user experiences while ensuring seamless functionality and performance. My expertise spans Angular for front-end development, Node.js and Express.js for back-end solutions, and MongoDB for efficient data management. With a collaborative mindset and a drive for innovation, I am committed to delivering high-quality, scalable applications that exceed expectations.
                    </Typography>
                </Grid>
                <Grid item md={6} >

                </Grid>
            </Grid>

            <Grid container style={{ height: '100%' }} spacing={2} className="section">
                <Grid item md={6} >
                </Grid>
                <Grid item md={6} >
                    <Typography variant="h4" className="heading" mb={2} color={COLORS.primary1}> My Skills</Typography>
                    <Typography variant="p" mb={2} color={COLORS.primary1}> Technologies I've been working with recently.</Typography>
                    <div className="skill-container">
                        {skills.map(skill => <Tooltip title={skill.toLocaleUpperCase()}><div className="skill-icon"><img width={'100%'} src={`${process.env.PUBLIC_URL}/skills/${skill}.png`} alt={`${skill}`} /></div> </Tooltip>)}
                    </div>
                </Grid>
            </Grid>
        </Box>

        <Box sx={{ flexGrow: 1 }} id="projects" className="section" style={{ backgroundColor: COLORS.gray1 }}>
        <Grid item sm={12} className="section">
        <Typography variant="h4" className="heading" mb={2} color={COLORS.primary1}> My Projects</Typography>
        <Typography variant="p" mb={2} color={COLORS.primary1}> Somethings I've buit so far.</Typography>
        <Grid container sm={12} spacing={2} mt={2}>
        {projects.map(project => <Grid  sm={3} item><Project project={project} /></Grid>)}
        </Grid>
        </Grid>
        </Box>

        <Box sx={{ flexGrow: 1 }} id="blogs" className="section" style={{ backgroundColor: COLORS.gray1 }}>
        <Grid item sm={12} className="section">
        <Typography variant="h4" className="heading" mb={2} color={COLORS.primary1}> My Blogs</Typography>
        <Typography variant="p" mb={2} color={COLORS.primary1}> I share insights, tutorials, and updates about software development, tech trends, and my personal projects.</Typography>
        <Grid container sm={12} spacing={2} mt={2}>
        {blogs.map(blog => <Grid  sm={3} item><Blog project={blog} /></Grid>)}
        </Grid>
        </Grid>
        <div style={{display: 'flex', justifyContent: 'center'}}>
        <Button style={{ backgroundColor: COLORS.primary, color: '#fff' }}
                    component="a"
                    href={`https://codescript.in/`}
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="contained"
                    tabIndex={-1}
                    startIcon={<ExpandMore />}
                > Load More </Button>
        </div>
        </Box>
        <Box sx={{ flexGrow: 1 }} id="contact" className="section" style={{ backgroundColor: COLORS.gray1 }}>
        <Grid container spacing={2} className="section">
        <Grid sm={12}>
        <Typography variant="h4" className="heading" mb={2} color={COLORS.primary1}> Get In Touch</Typography>
        </Grid>
        <Grid sm={6}  mt={2}>
        <div className="form"> 
        <Grid container>
        <Grid sm={6} style={{padding:'0 2px 0 0',width:'100%'}} mt={1}>
        <TextField style={{width:'100%'}} id="standard-basic" label="Name" variant="outlined" />
        </Grid>
        <Grid sm={6} style={{width:'100%'}} mt={1}>
        <TextField style={{width:'100%'}} id="standard-basic" label="Email" variant="outlined" />
        </Grid>
        </Grid>
        <TextField id="standard-basic" label="Message" rows={10} multiline variant="outlined" />
        <Button style={{width:'100px'}}
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<Send />}>Send</Button>
        </div>
        </Grid>
        <Grid sm={6} className="developer">
            <img  height="80%" alt="Developer" src="dev.png"/>
        </Grid>
        </Grid>
        </Box>


        <Footer/>
    </>
}

export default MainPage;